import FJModal from '../FJModal';
import FJWarningModal from './FJWarningModal';
import { FJModalsAction } from '../../../redux/action/FJModalsAction';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';

const FJWarningModalContainer = () => {
    const dispatch = useAppDispatch();
    const warningModalData = useAppSelector(state => state.modals.warningModalData);
    const { title, content, display, footerDates } = warningModalData;

    const onClose = () => {
        dispatch(FJModalsAction.hideWarningModalAction());
    };

    return (
        <FJModal visible={display}>
            <FJWarningModal title={title} content={content} footerDates={footerDates} onClose={onClose} />
        </FJModal>
    );
};

export default FJWarningModalContainer;
